import { resolve } from "../../init/store";
import { isApproveAvailableForAdmin } from "./request-center/request-center.functions";

export class Controller {

    /** @ngInject */
    constructor(CompanyUserResource, $rootScope, $state, LicenseManagementService) {
        this.CompanyUserResource = CompanyUserResource;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.LicenseManagementService = LicenseManagementService;
    }

    $onInit() {
        this.initCompanyRoles();
        this.initUserRoles();
        this.previousState = this.$state.current.name;
        resolve.hasRequests = this.hasRequests();
    }

    hasRequests() {
        for(let request of this.requests) {
            if(isApproveAvailableForAdmin(request)) {
                return true;
            }
        }
        return false;
    }

    companyRoleIconClass(role) {
        return ({
            'APPLICATION_ADMIN': 'fa fa-list-alt',
            'DEVELOPER_ADMIN': 'fa fa-wrench',
            'ORGANIZATION_ADMIN': 'fa fa-sitemap',
            'READ_ONLY_ADMIN': 'fa fa-eye',
            'SUPER_ADMIN': 'fa fa-building',
            'SAASPASS_ADMIN': 'fa fa-building',
        })[role];
    }

    onUserCompaniesDropdownToggle() {
        this.userCompaniesDropdownSearchKey = '';
    }

    logAdminDevSwitchToCompany(companyId) {
      this.$rootScope.logCompanyAccessed$ =  this.CompanyUserResource
            .logCompanyAccessed(companyId)
    }

    /** @private */
    initCompanyRoles() {

        const role = this.currentCompany.authoritiesConstants;
        const hasRole = (...roles) => ['SAASPASS_ADMIN', 'SUPER_ADMIN', 'READ_ONLY_ADMIN', ...roles].includes(role);

        this.canView = {
            'reseller': hasRole(),

            'saaspass-admin': role === 'SAASPASS_ADMIN',
            'directory-services': hasRole('ORGANIZATION_ADMIN'),
            'directory-groups': hasRole('ORGANIZATION_ADMIN'),
            'saaspass-users': hasRole(),
            'directory-integration': hasRole(),

            'applications-group': hasRole('APPLICATION_ADMIN', 'DEVELOPER_ADMIN'),
            'applications': hasRole('APPLICATION_ADMIN'),
            'sharing-center': hasRole(),
            'hard-token-management': hasRole(),
            'software-license-management': hasRole('APPLICATION_ADMIN'),
            'computer-protection': hasRole('APPLICATION_ADMIN'),
            'slack-info': hasRole(),
            'google-marketplace-instructions': hasRole(),
            'custom-app-integration': hasRole('DEVELOPER_ADMIN'),
            'idp-authenticators': hasRole('DEVELOPER_ADMIN'),
            'saaspass-connect': hasRole('DEVELOPER_ADMIN'),

            // 'saaspass-vpn': hasRole('DEVELOPER_ADMIN'),
            'saaspass-vpn': false,
            
            'sms-services': hasRole(),
            'policies': hasRole(),

            'recovery': hasRole(),
            'request-center': hasRole(),
            'administrators': hasRole(),
            'reports-main': hasRole(),
            'corporate-settings': hasRole(),
            'license-management': this.licenseInfo && hasRole(),
            'domains': hasRole(),
        };
    }

    /** @private */
    initUserRoles() {
        this.isGoogleUser = this.account.roles.includes('ROLE_GOOGLE_USER');
    }

    isReseller() {
        return this.currentCompany.companyType === 'RESELLER';
    }

    portalActionsRestricted() {
        return this.licenseInfo.licenseStatus == 'UNLICENSED' && this.licenseInfo.portalActionsRestricted;
    }

    showLicenseInfoBar() {
        let currentState = this.$state.current.name;
        if(!currentState.startsWith('company.license-management')) {
            if(this.previousState !== currentState) {
                this.LicenseManagementService.licenseCheck(this.companyId).then(licenseInfo => {
                    this.licenseInfo = licenseInfo;
                });
            }
            this.previousState = currentState;
            if (!this.licenseInfo || this.licenseInfo.licenseStatus == 'LICENSED' && !this.licenseInfo.appsLoginRestricted && !this.licenseInfo.thereUnhandledViolation && !this.licenseInfo.showPaymentMethodWarning) {
                return false;
            }
            return true;
        } else {
            return false;
        }
    } 
}



// WEBPACK FOOTER //
// ./src/portal/states/company/company.controller.js